import React, { useState } from "react";
import { Send } from "lucide-react";
import { Button, Input, Label } from "../ui";
import { ReviewFormData } from "./types";

type AskUserStepProps = {
  review: ReviewFormData;
  onSubmit: (data: { user_id: string }) => void;
  isSubmitting?: boolean;
};

const AskUserStep: React.FC<AskUserStepProps> = (props) => {
  const [userId, setUserId] = useState(props.review.user_id || "");

  return (
    <>
      <p className="mb-4">
        Tu veux participer à notre tirage au sort ? Donne nous ton email !
      </p>
      <div>
        <Label className="mb-2" htmlFor="user_id">
          Email
        </Label>
        <Input
          type="email"
          id="user_id"
          placeholder="Email"
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
        />
      </div>
      <Button
        onClick={() => props.onSubmit({ user_id: userId })}
        size="lg"
        className="w-full mt-4"
        disabled={!userId || props.isSubmitting}
      >
        <Send className="size-4" />
        {props.isSubmitting ? "Envoi en cours..." : "Confirmer et envoyer"}
      </Button>
      <div className="mt-4">
        <p className="text-xs text-gray-500">
          <b>Protection des données personnelles</b>
          <br />
          Les données personnelles collectées dans le cadre de ce sondage sont
          traitées uniquement dans le but de permettre la participation au
          tirage au sort et l'attribution des cartes cadeaux. Ces données sont
          conservées pendant une durée maximale de 6 mois, puis supprimées.
          <br />
          Votre adresse email ne sera en aucun cas utilisée à d'autres fins,
          partagée avec des tiers ou cédée à des fins commerciales.
          <br />
          Vous disposez d’un droit d’accès, de rectification, de suppression,
          ainsi que d’un droit d’opposition au traitement de vos données, que
          vous pouvez exercer en nous contactant à l’adresse suivante :
          dpo@qualimetrie.com.
        </p>
      </div>
    </>
  );
};

export default AskUserStep;
